module.exports = __webpack_public_path__ + "static/fanruan-ask.ba2c194d.png";